



















































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment-timezone';
import { formatNumber, formatCouponText } from '@/utils/helpers';
import constants from '@/utils/constants';
import SelectTable from './SelectTable.vue';
import DiscountModal from '../DiscountModal/DiscountModal.vue';
@Component({
  filters: {
    formatDate(val: any) {
      let date: any = val;
      if (moment(date).isValid()) {
        date = moment(date).format('MMM DD, YYYY HH:mm:ss');
      }
      return date;
    },
    formatPrice(val: any) {
      let date: any = val;
      return formatNumber(date);
    }
  },
  components: {
    SelectTable,
    DiscountModal
  }
})
export default class BillItemCard extends Vue {
  @Prop() item!: any;
  @Prop() billListFilter!: any;
  @Prop(Object) orderStatus!: Object;
  @Prop(Function) showOrderDetail!: Function;
  @Prop(Function) updateBillStatus!: Function;
  @Prop(Function) cancelBill!: Function;
  cancelBillPrice: Array<any> = [];
  payingOnlinePrice: Array<any> = [];
  openStatusShowMenu: Array<any> = [];
  payOnlineStatusShowMenu: Array<any> = [];
  payFailedStatusShowMenu: Array<any> = [];
  padStatusShowMenu: Array<any> = [];
  payOnCashierStatusShowMenu: Array<any> = [];
  cancelStatusShowMenu: Array<any> = [];
  compleateStatusShowMenu: Array<any> = [];
  showSelectTable: boolean = false;
  constants: any = constants;
  formatCouponText: Function = formatCouponText;
  coupon: any = {};
  showDiscount: boolean = false;

  get billingMenus() {
    return this.$store.getters.GetIncludeAllMenu;
  }
  get canDiscount() {
    return (this.item.pos_input &&
      (this.orderStatus[this.item.billing_status_bo_label].text === 'OPEN' ||
      this.orderStatus[this.item.billing_status_bo_label].text === 'PAYMENT FAILED' ||
      this.orderStatus[this.item.billing_status_bo_label].text === 'REQUESTING CASHIER PAYMENT' ||
      this.orderStatus[this.item.billing_status_bo_label].text === 'PAYING AT HOTEL'));
  }
  formatPrice(val: any) {
    let date: any = val;
    return formatNumber(date);
  }
  showDiscountHandle() {
    this.showDiscount = true;
  }
  hideDiscountHandle() {
    this.showDiscount = false;
  }
  updateDiscountHandle(payload) {
    this.hideDiscountHandle();
    this.$store.dispatch('UpdateBillDiscount', {
      billingNo: this.item.billing_no,
      promoType: payload.promo_type,
      promoID: payload.promo_type === 2 ? payload.coupon.id : 0,
      promoValue: payload.promo_type !== 2 ? payload.promo_value : 0,
      discountName: payload.promo_type !== 2 ? payload.discount_name : '',
    }).then(res => {
      if (res.data.invalidMessage === constants.UPPER_SUCCESS) {
        this.$store.dispatch('GetAllBillList', this.billListFilter);
      }
    });
  }
  printHandle = (item, event) => {
    if (event) {
      event.stopPropagation
        ? event.stopPropagation()
        : (event.cancelBubble = true);
    }
    const UserName = localStorage.getItem('UserName');
    if (window && typeof (window as any).android !== 'undefined') {
      (window as any).android.printBillOrder(
        JSON.stringify(item),
        UserName,
        JSON.stringify(this.billingMenus)
      );
    }
  };
  openSelectTable(item, event) {
    if (event) {
      event.stopPropagation
        ? event.stopPropagation()
        : (event.cancelBubble = true);
    }
    this.showSelectTable = true;
  }
  hideSelectTable() {
    this.showSelectTable = false;
  }
  printKitchenHandle = (item, event) => {
    if (event) {
      event.stopPropagation
        ? event.stopPropagation()
        : (event.cancelBubble = true);
    }
    const UserName = localStorage.getItem('UserName');
    if (window && typeof (window as any).android !== 'undefined') {
      (window as any).android.printBill(JSON.stringify(item), UserName);
    }
  };
  @Watch('showSelectTable')
  watchModelShow() {
    if (this.showSelectTable) {
      document.getElementsByTagName('body')[0].className = 'noScroll';
    } else {
      document.body.classList.remove('noScroll');
    }
  }
  mounted() {
    const data: any = [];
    const price: any = [];
    if (
      this.item.billing_status === 'OPEN' ||
      this.item.billing_status === 'PAYING_ON_CASHIER' ||
      this.item.billing_status === 'PAYING_ONLINE_FAILED' ||
      this.item.billing_status === 'PAYING_AT_HOTEL'
    ) {
      this.item.sub_orders.map(items => {
        if (items.order_status !== constants.UPPER_CANCELLED) {
          items.menu_items.map(item => {
            data.push(item.menu_item_code);
          });
        }
      });
      this.openStatusShowMenu = Array.from(new Set(data));
      this.payOnCashierStatusShowMenu = Array.from(new Set(data));
      this.payFailedStatusShowMenu = Array.from(new Set(data));
    } else if (this.item.billing_status === 'PAYING_ONLINE') {
      this.item.sub_orders.map(items => {
        if (items.order_status !== constants.UPPER_CANCELLED) {
          items.menu_items.map(item => {
            data.push(item.menu_item_code);
            price.push(item.sum_price);
          });
        }
      });
      this.payingOnlinePrice = price.reduce((a, b) => {
        return a + b;
      }, 0);
      this.payOnlineStatusShowMenu = Array.from(new Set(data));
    } else if (this.item.billing_status === constants.UPPER_CANCELLED) {
      this.item.sub_orders.map(items => {
        if (items && items.cancel_reason === 'BILLING_CANCEL') {
          items.menu_items.map(item => {
            data.push(item.menu_item_code);
            price.push(item.sum_price);
          });
        }
      });
      this.cancelBillPrice = price.reduce((a, b) => {
        return a + b;
      }, 0);
      this.cancelStatusShowMenu = Array.from(new Set(data));
    } else if (
      this.item.billing_status === 'PAID' ||
      this.item.billing_status === 'COMPLETED'
    ) {
      this.item.sub_orders.map(items => {
        if (items.order_status !== constants.UPPER_CANCELLED) {
          items.menu_items.map(item => {
            data.push(item.menu_item_code);
          });
        }
      });
      this.padStatusShowMenu = Array.from(new Set(data));
      this.compleateStatusShowMenu = Array.from(new Set(data));
    }

    if (this.item.coupon_list && this.item.promo_id) {
      const filterCoupon = this.item.coupon_list.result.filter((item: any) => item.id === this.item.promo_id);
      if (filterCoupon.length) {
        this.coupon = filterCoupon[0];
      }
    }
  }
}
